<template>
  <v-container>
 


      <v-flex xs12 sm6 align-center
        >
        <v-img
          class="white--text align-center"
          src="https://firebasestorage.googleapis.com/v0/b/valoradesign-542be.appspot.com/o/TITULO%20ROLLER%20BLACKOUT.png?alt=media&token=1f3dba2f-c3c8-4c16-9862-2277fa7c027e"
        >
        </v-img>

           <h3
            class="text-center  text-justify  Subtitle-1 font-weight-light white--text title mb-1"
          >
       
        </h3>
      </v-flex>

<v-parallax
      dark
      height="500"
      src="https://www.narvik.cl/wp-content/uploads/2015/08/roller-blackout-01.jpg"
      gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
    >
      <v-row align-center align="center" justify="center">
        <v-col cols="8" class="text-center">
          <h1 class="font-weight-medium">
            {{ descripcion }}
          </h1>
          <h4 class="subheading"></h4>
        </v-col>
      </v-row>
    </v-parallax>
  <br />
    <br />

  <v-row no-gutters>
        <v-col
          cols="12"
          sm="12"
          md="6"
         xs="12"
          
        >

          <v-card
        color="black"
          >

             <iframe
  
          src="//fast.wistia.net/embed/iframe/fx71tmzj5u"
          frameborder="0"
          scrolling="no"
           
          name="wistia_embed"
          allowfullscreen
          mozallowfullscreen
          webkitallowfullscreen
          oallowfullscreen
          msallowfullscreen
        :width="Width"
        :height="Width"    
        >

        </iframe>

  
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="6"
           sm="12"
            xs="12"
           
        >




          <v-card
          color = "black"
            class="pa-2"
            outlined
            tile
          >
          <v-card>
      
      <v-tabs dark horizontal>
        <v-tab>
    
        DESCRIPCIÓN
        </v-tab>
        <v-tab>
   
       VIDEOS
        </v-tab>
        <v-tab>
    FOTOS
        </v-tab>
  
        <v-tab-item>
          <v-card  class="text-justify " flat>
            
             <v-card-title class="text-h5">
             Colección Blackout
              </v-card-title>
  
             <v-card-text> Es una cortina cuya tela asegura por su composición 70% PVC y 30% Poliéster un bloqueo total de la luz y de las condiciones térmicas del ambiente con el consiguiente ahorro energético. <br/>      <br/>   Es una colección que se aplica muy bien a los dormitorios y a los espacios en que se requiere oscuridad y privacidad. En términos de estética hemos incorporado a nuestra línea tradicional la colección roller Blackout Texturado incorporando diseños suaves que otorgan mayor elegancia y calidez a los ambientes. <br/>      <br/>  Disponemos de una variedad de tonos neutros: blancos, arenas y grises y mantenemos el atributo de tela reverso blanco para cumplir con las exigencias de condominios. Sus componentes y mecanismos aseguran resistencia y durabilidad.  </v-card-text>
          
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card color="black" flat>

      <v-row>

      <br/>  <br/>      <br/>   <br/>      <br/>        
      <v-col
         v-for="(social, i) in youtubeLink"
        :key="i"
        class="d-flex child-flex"
        cols="6"
      >
    <br/> <br/>   <br/>      <br/>            
    <LazyYoutube
       
        :src="social.video"
        max-width="250x"
        aspect-ratio="16:9"
        :thumbnail-listeners="{ load: foo }"
       
    />
      </v-col>
    </v-row>

            <v-card-text>
           
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card color="black" flat>
         
     <v-row>
          <v-spacer></v-spacer>
          <v-col
            v-for="card in fotos"
            :key="card"
            cols="12"
            sm="6"
            md="6"
          >
            <v-card >
           
              <v-img
                :src="card.fotos"
                height="200px"
              >
               
              </v-img>
  
              
            </v-card>
          </v-col>
        </v-row>



          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
          </v-card>
        </v-col>
      </v-row>






   
   
   

    
    <br />
    <br />

 <v-divider color="white" inset></v-divider>
   
 
  </v-container>
</template>

<script>
import db from "@/firebase/init.js";
import { LazyYoutube,  } from "vue-lazytube";

export default {
  name: "ABAP1",
    components: {  LazyYoutube, 
        },
  props: [],

  data() {
    return {

fotos:[
      { titulo:"", fotos:"https://firebasestorage.googleapis.com/v0/b/valoradesign-542be.appspot.com/o/blackout_tradicionalo_izurieta_3.jpg?alt=media&token=67af015e-6059-4dee-9474-12dd057a9038"},
      { titulo:"",fotos:"https://firebasestorage.googleapis.com/v0/b/valoradesign-542be.appspot.com/o/blackout_velvet_izurieta_1.jpg?alt=media&token=6a5650d9-6e46-44fa-9f89-1f4cb7588b12"},
      { titulo:"",fotos:"https://www.narvik.cl/wp-content/uploads/2015/10/roller-blackout-08.jpg"},
       { titulo:"",fotos:"https://www.narvik.cl/wp-content/uploads/2015/08/roller-blackout-04.jpg"},
      { titulo:"",fotos:"https://www.narvik.cl/wp-content/uploads/2015/10/roller-blackout-07.jpg"},
      { titulo:"",fotos:"https://www.narvik.cl/wp-content/uploads/2016/01/roller-blackout-09.jpg"},
],

     cards: [
    
      { title: '1', src: '',  flex: 6 ,video:"//fast.wistia.net/embed/iframe/1qxq3kwkv3",color:"black"},
      { title: '2', src: '', flex: 6 , color:"grey" },
    ],    
reveal: false,
 youtubeLink:[{video:'https://www.youtube.com/watch?v=rZ_nRxNBw98' },{video:'https://www.youtube.com/watch?v=6VOqbNsJRng' },{video:'https://www.youtube.com/watch?v=yE9Zt3Fzpt8' },{video:'https://www.youtube.com/watch?v=X5zADiWmDIQ' },{video:'https://www.youtube.com/watch?v=Mxz_5v2IIAs' },{video:'https://www.youtube.com/watch?v=GsyQaoK2gpw' }, ],
  
 

 tab: null,
     

      productos: "",
      Titulo: " ",
      Descripcion: "",
      Linea: "",
      Lista: "",
   
    
    };
  },
  created() {
    var docRef = db.collection("web").doc("ABAP1");
    docRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          this.productos = doc.data().productos;
          this.Titulo = doc.data().Titulo;
          this.Descripción = doc.data().Descripción;
          this.Lista = doc.data().Lista;
          this.Linea = doc.data().Linea;
       

        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
      });
  },
  methods: {
    show(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },

    methods: {
      web() {
        this.$router.push({ path: "web" });
        this.dialog = false;
      },

      ecommerce() {
        this.$router.push({ path: "/ecommerce" });
        this.dialog = false;
      },

      market() {
        this.$router.push({ path: "/market" });
        this.dialog = false;
      },
      apps() {
        this.$router.push({ path: "/apps" });
        this.dialog = false;
      },
      foto() {
        this.$router.push({ path: "/foto" });
        this.dialog = false;
      },
      gestion() {
        this.$router.push({ path: "/social" });
        this.dialog = false;
      },
      inicio() {
        this.$router.push({ path: "/" });
        this.dialog = false;
      },
    },
  },

  computed: {
   

  Width() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "350"; 
        case "sm":
          return "550";
        case "md":
          return "550";
        case 'lg':
          return "550";
        case 'xl':
          return "550";
        default:
          return '400px'
      }
    },


    height() {
      return this.width / 1.77;
    },
  },
};
</script>

